export default __webpack_public_path__ + "static/media/matt.0370e5f2.jpg";